<template>
  <div>
    <info-list
      :form-model="formModel"
      :headers="headers"
    ></info-list>
  </div>
</template>

<script>
import InfoList from '@/modules/bankruptcy/components/bankruptcy-file/info-list.vue';
import { toHijriDate } from '@/helpers/utils';
export default {
  components: { InfoList },
  props: {
    formModel: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      toHijriDate,
      headers: [
        {
          key: 'identityTypeName',
          text: this.local.bankruptcy.requestDetails.partners.identityType,
        },
        {
          key: 'identityNumber',
          text: this.local.bankruptcy.requestDetails.partners.identityNumber,
        },
        {
          key: 'dateOfBirth',
          text: this.local.bankruptcy.requestDetails.partners.dateOfBirth,
          formatter: toHijriDate,
        },
        {
          key: 'fullName',
          text: this.local.bankruptcy.requestDetails.partners.thePartner,
        },
        {
          key: 'commercialRegistrationNumber',
          text: this.local.bankruptcy.requestDetails.partners.commercialRegistrationNumber,
        },
        {
          key: 'organizationName',
          text: this.local.bankruptcy.requestDetails.partners.thePartner,
        },
        {
          key: 'share',
          text: this.local.bankruptcy.requestDetails.partners.share,
        },
        {
          key: 'managerFullName',
          text: this.local.bankruptcy.requestDetails.partners.managerName,
        },
        {
          key: 'managerIdentityNumber',
          text: this.local.personInformation.socialId,
        },
        {
          key: 'passportDate',
          text: this.local.personInformation.passportDate,
        },
        {
          key: 'passportSource',
          text: this.local.personInformation.passportSource,
        },
      ],
    };
  },
  computed: {},
  mounted() {

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
